import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import "./ProviderListPage.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import formatCnpj from '../../helpers/formatCnpj';
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import havePermissionTo from '../../utils/havePermission';
import { ButtonStandard, ProviderFilter, ToastMessage } from "../../components";

function ProviderListPage(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);
    const permissions = useSelector(state => state.authorization.permissions);
    const filters = useSelector(state => state.provider.filter);

	const providerList            = useSelector(state => state.provider.providerList.fornecedoresFiltrados);
    const isLoadingProviderList   = useSelector(state => state.provider.isLoadingProviderList);
    const isLoadingProviderUpdate = useSelector(state => state.provider.isLoadingProviderUpdate);
    const selectedProvider        = useSelector(state => state.provider.selectedProvider);
    const providerPreScheduling   = useSelector(state => state.provider.providerIdPreScheduling);

    const [canEdit, setCanEdit] = useState(false)

    const providerToast = useSelector(state => state.provider.providerToast);

    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');
    
	const pageMessages = messages[lang].providerListPage;
	const titleTable   = messages[lang].providers;
    const titlePage    = messages[lang].providersInquiry;

	const header = [
		pageMessages.nome,
		pageMessages.cnpj,
		pageMessages.cidade,
        pageMessages.uf,
        pageMessages.exigirDeclProdutor,
        pageMessages.certOrigem,
        pageMessages.details,
        pageMessages.preAgendamento
	];

    useEffect(() => {	
        setShowToast(providerToast.showToast)
        setMessageError(providerToast.message)
        setMessageType(providerToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [providerToast]);
    
    useEffect(() => {
        if (havePermissionTo("edit-provider-list", permissions)) {
            setCanEdit(true)
        }

		dispatch({
			type: 'GET_PROVIDERS',
            filter: filters
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
		if (selectedProvider.id) {
			history.push('/provider-details')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedProvider]);

    useEffect(() => {
		if (providerPreScheduling.id) {
			history.push('/pre-scheduling-list')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [providerPreScheduling]);

    const changeDeclProdutor = (id, declaracaoProdutor, item) => {
        item.exigirDeclProdutor = declaracaoProdutor

        dispatch({
			type: 'UPDATE_DECLARACAO_PRODUTOR',
            payload: {
                fornecedorId: id,
                exigirDeclProdutor: declaracaoProdutor
            }
		})        
    }

    const changeCertifOrigem = (id, exigirCertifOrigem, item) => {
        item.exigirCertifOrigem = exigirCertifOrigem

        dispatch({
			type: 'UPDATE_EXIGIR_CERTIF_ORIGEM',
            payload: {
                fornecedorId: id,
                exigirCertifOrigem: exigirCertifOrigem
            }
		})        
    }

	const mappedProviderList = () => {
		return providerList.map((item) => {
			return [
					item.nome,
                    item.cnpj ? formatCnpj(item.cnpj) : '',
                    item.cidade,
                    item.uf,
                    {
						text: 
                        <div key={item.id} className="text-2">
                            <Form.Check
                                inline
                                label={messages[lang].yes}
                                name={item.id}
                                type="radio"
                                id={item.id}
                                defaultChecked={item.exigirDeclProdutor ? true : false}
                                disabled={isLoadingProviderUpdate || !canEdit}
                                onChange={() => changeDeclProdutor(item.id, true, item)}
                            />
                            <Form.Check
                                inline
                                label={messages[lang].no}
                                name={item.id}
                                type="radio"
                                id={item.id}
                                defaultChecked={!item.exigirDeclProdutor || item.exigirDeclProdutor === false ? true : false}
                                disabled={isLoadingProviderUpdate || !canEdit}
                                onChange={() => changeDeclProdutor(item.id, false, item)}
                            />
                        </div>,
					},
                    {
                        text: 
                        <div key={item.id + '_certOrigem'} className="text-2">
                            <Form.Check
                                inline
                                label={messages[lang].yes}
                                name={item.id + '_certOrigem'}
                                type="radio"
                                id={item.id + '_certOrigem'}
                                defaultChecked={item.exigirCertifOrigem ? true : false}
                                disabled={isLoadingProviderUpdate || !canEdit}
                                onChange={() => changeCertifOrigem(item.id, true, item)}
                            />
                            <Form.Check
                                inline
                                label={messages[lang].no}
                                name={item.id + '_certOrigem'}
                                type="radio"
                                id={item.id + '_certOrigem'}
                                defaultChecked={!item.exigirCertifOrigem || item.exigirDeclProdutor === false ? true : false}
                                disabled={isLoadingProviderUpdate || !canEdit}
                                onChange={() => changeCertifOrigem(item.id, false, item)}
                            />
                        </div>,
                    },
                    {
						text: <i className="icon-pen" />,
						onClick: () => {
							dispatch({
								type: 'SET_SELECTED_PROVIDER',
								payload: {
                                    id: item.id,
                                    data: item
                                }
							})
						},
					},
                    {
						text: <i className="icon-pen" />,
						onClick: () => {
							dispatch({
								type: 'SET_PROVIDER_PRE_SCHEDULING',
                                payload: {
                                    id: item.id,
                                    data: item
                                }
							})
						},
					}
				]

		});
	}

    const getProviders = () => {
        dispatch({
			type: 'GET_PROVIDERS',
            filter: filters
		})
	}

	return (
		<div className="provider-list-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
            {
                isLoadingProviderUpdate ? 
                <div className="loader">
                    <LoadingSpinner />    
                </div>                 
                :

                null
            }            
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <ProviderFilter />
            </Container>

            <Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={messages[lang].searchProvider}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getProviders()}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedProviderList()}
                        isLoading={isLoadingProviderList ? true : false}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(ProviderListPage);